(() => {
  const passedForms = new WeakSet();
  const pendingForms = new WeakSet();

  class CartConsent extends HTMLElement {
    connectedCallback() {
      this.checkbox = this.querySelector('[data-dm-consent]');
      this.form = this.closest('form');
      this.error = this.querySelector('.dm-cart-consent__error');
      if (!this.checkbox || !this.form) return;
      this.checkbox.checked = false;
      this.onChange = () => {
        this.error.hidden = true;
        this.error.textContent = '';
        this.checkbox.removeAttribute('aria-invalid');
        this.updateButtons();
      };
      this.checkbox.addEventListener('change', this.onChange);
      this.updateButtons();
    }

    disconnectedCallback() {
      this.checkbox?.removeEventListener('change', this.onChange);
    }

    updateButtons() {
      this.form.querySelectorAll('[name="checkout"]').forEach(button => {
        button.disabled = pendingForms.has(this.form);
      });
    }

    showError(message) {
      this.error.textContent = message;
      this.error.hidden = false;
      this.checkbox.setAttribute('aria-invalid', 'true');
      this.checkbox.focus();
    }
  }

  if (!customElements.get('dm-cart-consent')) {
    customElements.define('dm-cart-consent', CartConsent);
  }

  document.addEventListener('invalid', event => {
    if (!event.target.matches('[data-dm-consent]')) return;
    const consent = event.target.closest('dm-cart-consent');
    if (!consent) return;
    event.preventDefault();
    consent.showError(consent.dataset.requiredMessage);
  }, true);

  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const consent = form.querySelector('dm-cart-consent');
    if (!consent) return;
    const isCheckout = event.submitter?.name === 'checkout' || !event.submitter;
    if (!isCheckout) return;
    if (passedForms.has(form)) {
      passedForms.delete(form);
      return;
    }
    event.preventDefault();
    event.stopImmediatePropagation();
    if (pendingForms.has(form)) return;
    if (!consent.checkbox.checked) {
      consent.showError(consent.dataset.requiredMessage);
      return;
    }
    const submitter = event.submitter || form.querySelector('[name="checkout"]');
    const date = new Date().toISOString();
    const attributes = {};
    form.querySelector('[data-dm-consent-date]').value = date;
    form.querySelectorAll('[name^="attributes["]').forEach(input => {
      const match = input.name.match(/^attributes\[(.+)\]$/);
      if (match && (input.type !== 'checkbox' || input.checked)) {
        attributes[match[1]] = input.value;
      }
    });
    pendingForms.add(form);
    consent.updateButtons();
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes })
      });
      if (!response.ok) throw new Error('Cart confirmation update failed');
      const cart = await response.json();
      if (cart.attributes?.Sozlesme_Onayi !== 'Onaylandi' || cart.attributes?.Sozlesme_Onay_Tarihi !== date) {
        throw new Error('Cart confirmation not stored');
      }
      pendingForms.delete(form);
      if (!form.isConnected || !consent.checkbox.checked) return;
      consent.updateButtons();
      passedForms.add(form);
      form.requestSubmit(submitter);
    } catch (error) {
      pendingForms.delete(form);
      passedForms.delete(form);
      consent.updateButtons();
      consent.showError(consent.dataset.errorMessage);
    }
  }, true);

  document.addEventListener('click', event => {
    const checkout = event.target.closest('[name="checkout"]');
    const consent = checkout?.form?.querySelector('dm-cart-consent');
    if (consent && !consent.checkbox.checked) {
      event.preventDefault();
      event.stopImmediatePropagation();
      consent.showError(consent.dataset.requiredMessage);
      return;
    }
    const link = event.target.closest('[data-dm-document]');
    if (link) {
      const dialog = document.getElementById(link.dataset.dmDocument);
      if (dialog instanceof HTMLDialogElement) {
        event.preventDefault();
        event.stopImmediatePropagation();
        dialog.showModal();
      }
      return;
    }
    const closeButton = event.target.closest('[data-dm-document-close]');
    if (closeButton) closeButton.closest('dialog')?.close();
    if (event.target instanceof HTMLDialogElement) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) {
        event.target.close();
      }
    }
  }, true);

  window.addEventListener('pageshow', event => {
    if (!event.persisted) return;
    document.querySelectorAll('dm-cart-consent').forEach(consent => {
      consent.checkbox.checked = false;
      consent.updateButtons();
    });
  });
})();

